export const argoSettings = {
  namespaced: true,
  appCode: 'WTR',
  roleAdmin: 'wtr.admin',
  roleReg: 'wtr.reg',
  prefix: 'argo',
  persist: true
};